import React from 'react';
import { IExtension } from '../Interfaces/IExtension';
import { Box } from '@mui/material';
import { ExtensionCard } from './ExtensionCard';

interface IProps {
  extensionArray: IExtension[];
}

export const MarketplaceTab: React.FC<IProps> = ({ extensionArray }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2, // Abstand zwischen den Elementen
        justifyContent: 'flex-start', // Optional für bessere Ausrichtung
      }}
    >
      {extensionArray.map(ext => (
        <ExtensionCard key={`extension-${ext}`} extension={ext} />
      ))}
    </Box>
  );
};
